module.exports = __webpack_public_path__ + "static/img/19017B_4_C_20230521_LC.fa19f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19017B_4_C_20230521_LC.png
// module id = b9ZW
// module chunks = 0